import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="5"
    height="4"
    viewBox="0 0 5 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.0272597 3.25386C0.000191921 3.18079 -0.00691873 3.10036 0.00682712 3.02276C0.020573 2.94516 0.0545576 2.87387 0.104483 2.8179L2.2471 0.418087C2.28026 0.380899 2.31965 0.351398 2.363 0.33127C2.40635 0.311141 2.45282 0.300781 2.49975 0.300781C2.54668 0.300781 2.59315 0.311141 2.6365 0.33127C2.67985 0.351398 2.71923 0.380899 2.7524 0.418087L4.89502 2.8179C4.94501 2.87384 4.97907 2.94513 4.99287 3.02276C5.00667 3.10039 4.9996 3.18086 4.97255 3.25398C4.9455 3.3271 4.89969 3.38959 4.84091 3.43354C4.78213 3.47748 4.71303 3.50091 4.64237 3.50084H0.357133C0.286505 3.50083 0.217468 3.47735 0.158751 3.43339C0.100034 3.38943 0.0542748 3.32695 0.0272597 3.25386Z"
      fill="currentColor"
      fillOpacity="0.6"
    />
  </svg>
);
export default SvgArrowUp;
